export const basicTreeSubTitle = [
  {
    text: "Use the dynamic tree view with checkboxes.",
  },
];

export const simpleTreeviewData = [
  {
    text: "root",
    expanded: true,
    items: [
      {
        text: "Applications",
        expanded: true,
        items: [
          {
            text: "Ecommerce",
            items: [{ text: "Product" }, { text: "Cart" }, { text: "Invoice" }],
          },
          {
            text: "Users",
            items: [{ text: "User-profile" }, { text: "User-edit" }, { text: "User-cards" }],
          },
          {
            text: "Chat",
            items: [{ text: "Chat-app" }, { text: "Video-chat" }],
          },
        ],
      },
      {
        text: "Components",
        expanded: true,
        items: [
          {
            text: "UI-Kits",
            items: [{ text: "Typography" }, { text: "Avatars" }, { text: "Grid" }],
          },
          {
            text: "Bonus-UI",
            items: [{ text: "Toasts" }, { text: "Rating" }, { text: "Pagination" }],
          },
          {
            text: "Charts",
            items: [{ text: "Apex-chart" }, { text: "Google-chart" }, { text: "Chartjs-chart" }],
          },
        ],
      },
      {
        text: "Miscellaneous",
        expanded: true,
        items: [
          {
            text: "Gallery",
            items: [{ text: "Gallery-grid" }, { text: "Gallery-grid-desc" }, { text: "Masonary-gallery" }],
          },
          {
            text: "Blog",
            items: [{ text: "Blog-details" }, { text: "Blog-single" }, { text: "Add-post" }],
          },
          {
            text: "Editors",
            items: [{ text: "CK-editors" }, { text: "MDE-editors" }, { text: "ACE-editors" }],
          },
        ],
      },
    ],
  },
];

export const DisabledTreeViewList = [
  {
    text: "root",
    expanded: true,
    items: [
      {
        text: "Applications",
        expanded: true,
        disabled: true,
        items: [
          {
            text: "Ecommerce",
            items: [{ text: "Product" }, { text: "Cart" }, { text: "Invoice" }],
          },
          {
            text: "Users",
            items: [{ text: "User-profile" }, { text: "User-edit" }, { text: "User-cards" }],
          },
          {
            text: "Chat",
            items: [{ text: "Chat-app" }, { text: "Video-chat" }],
          },
        ],
      },
      {
        text: "Components",
        expanded: true,
        items: [
          {
            text: "UI-Kits",
            items: [{ text: "Typography" }, { text: "Avatars" }, { text: "Grid" }],
          },
          {
            text: "Bonus-UI",
            items: [{ text: "Toasts" }, { text: "Rating" }, { text: "Pagination" }],
          },
          {
            text: "Charts",
            items: [{ text: "Apex-chart" }, { text: "Google-chart" }, { text: "Chartjs-chart" }],
          },
        ],
      },
      {
        text: "Miscellaneous",
        expanded: true,
        items: [
          {
            text: "Gallery",
            items: [{ text: "Gallery-grid" }, { text: "Gallery-grid-desc" }, { text: "Masonary-gallery" }],
          },
          {
            text: "Blog",
            items: [{ text: "Blog-details" }, { text: "Blog-single" }, { text: "Add-post" }],
          },
          {
            text: "Editors",
            items: [{ text: "CK-editors" }, { text: "MDE-editors" }, { text: "ACE-editors" }],
          },
        ],
      },
    ],
  },
];
